import { render, staticRenderFns } from "./CommentsOnLessonsHeader.vue?vue&type=template&id=09e3575a&scoped=true&"
import script from "./CommentsOnLessonsHeader.vue?vue&type=script&lang=ts&"
export * from "./CommentsOnLessonsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsOnLessonsHeader.vue?vue&type=style&index=0&id=09e3575a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3575a",
  null
  
)

export default component.exports